export default __webpack_public_path__ + "static/media/T124_RoHS.68d2a9a5.pdf";